"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _r10SourceLibrary = require("r10-source-library");
var _react = _interopRequireWildcard(require("react"));
var _useRecommendationSetup = require("../../hooks/recommendation/useRecommendationSetup");
var _useRecommendationStatus = require("../../hooks/recommendation/useRecommendationStatus");
var _BaseComponents = require("../StyledComponents/BaseComponents");
var _RecommendationBody = _interopRequireDefault(require("./RecommendationBody"));
var _useLocalTheme = _interopRequireDefault(require("../../hooks/useLocalTheme"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const StyledGridRow = (0, _BaseComponents.GrayBackground)(_r10SourceLibrary.GridRow);
const WrapperContainer = (0, _styledComponents.default)('div')(props => (0, _styledComponents.css)`
    width: 100%;
    & [class*='GridColumnstyle__GridColumn'] {
      padding: 0px ${props.recommendationPlanPadding}px;
      margin-bottom: ${props.recommendationPlanMargin}px;
    }
  `);
const RecommendationBodyWrapper = () => {
  (0, _useRecommendationSetup.useRecommendationSetup)();
  const breakpoints = (0, _r10SourceLibrary.useBreakpoints)();
  const {
    isRecommendationReady
  } = (0, _useRecommendationStatus.useRecommendationStatus)();
  const showGreyBackground = (0, _useLocalTheme.default)('recommendation.showGreyBackground', true);
  const spacingLevel = (0, _useLocalTheme.default)('recommendation.spacingLevel', 4);
  const recommendationPlanPadding = (0, _useLocalTheme.default)('recommendationPlanPadding', breakpoints.sm ? 8 : 25);
  const recommendationPlanMargin = (0, _useLocalTheme.default)('recommendationPlanMargin', 25);
  const Wrapper = showGreyBackground ? StyledGridRow : _react.Fragment;
  return isRecommendationReady ? /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": "recommendation-body-wrapper"
  }, /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(WrapperContainer, {
    recommendationPlanPadding: recommendationPlanPadding,
    recommendationPlanMargin: recommendationPlanMargin
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: spacingLevel
    }
  }, /*#__PURE__*/_react.default.createElement(_RecommendationBody.default, null)))))) : null;
};
var _default = RecommendationBodyWrapper;
exports.default = _default;